import { LocationPage } from "apps/batchOnboarding/location/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(LocationPage, "BulkLocationPage");
